import image1 from "./images/1.jpg";
import image2 from "./images/2.jpg";
import image3 from "./images/3.jpg";
import image4 from "./images/4.jpg";
import image5 from "./images/5.jpg";
// import image6 from "./images/6.jpg";
import image7 from "./images/7.jpg";
import image8 from "./images/8.jpg";
import image9 from "./images/9.jpg";
import image10 from "./images/10.jpg";
import image11 from "./images/11.jpg";
import image12 from "./images/12.jpg";

export const ProjectsList = [
    {
        projectImage: image1,
        projectName: "Soreal By Toniez",
        projectDescription:
            "An E-Commerce Cosmetics site with an admin area, fully seo based",
        languages: [
            "JavaScript",
            "HTML",
            "CSS",
            "Firebase",
            "PWA",
            "FormSpree",
            "SwiperJS",
        ],
        githubLink: "https://github.com/ryanfavour4/sorealbytoniez",
        liveLink: "https://sorealbytoniez.netlify.app/",
    },
    {
        projectImage: image2,
        projectName: "Intelligentsia Talk",
        projectDescription:
            "Motivational video streaming platform that connects you with mentors and life coaches",
        languages: [
            "React",
            "Mail Chimp",
            "CSS",
            "Firebase",
            "Contexts",
            "SwiperJS",
            "YT API",
        ],
        githubLink: "https://github.com/ryanfavour4/intelligentsiatalk",
        liveLink: "https://intelligentsiatalkv2.netlify.app/",
    },
    {
        projectImage: image3,
        projectName: "Jesus Empowerment Ministries",
        projectDescription:
            "Real time christian organization website aimed to support homeless kids and preaching the gospel",
        languages: [
            "JavaScript",
            "HTML",
            "CSS",
            "Firebase",
            "FormSpree",
            "SwiperJS",
        ],
        githubLink: "https://github.com/ryanfavour4/",
        liveLink: "https://jesusempowermentministries.netlify.app/",
    },
    {
        projectImage: image4,
        projectName: "Tandem Pharmacy",
        projectDescription:
            "An E-Commerce Site built for a pharmacy in my area, also with an admin section",
        languages: [
            "JavaScript",
            "HTML",
            "CSS",
            "Firebase",
            "FormSpree",
            "SwiperJS",
        ],
        githubLink: "https://github.com/ryanfavour4/",
        liveLink: "https://tandempharmacy.netlify.app/",
    },
    {
        projectImage: image5,
        projectName: "Intelligentsia Talk (pre launch)",
        projectDescription:
            "Intelligentsia Talk Pre launch site, technically this was used to rather invite expecting users to subscribe while we built the main site",
        languages: ["JavaScript", "HTML", "CSS", "FormSpree"],
        githubLink: "https://github.com/ryanfavour4/",
        liveLink: "https://intelligentsiatalk.netlify.app/",
    },
    // {
    //   projectImage: image6,
    //   projectName: "Myitura",
    //   projectDescription: "One of the very project that makes me happy, built by the ingenious team of TechBeaver (including me)",
    //   languages: [
    //     "TypeScript",
    //     "JavaScript",
    //     "SCSS",
    //     "CSS",
    //     "Firebase",
    //     "MobX",
    //     "Bootstrap",
    //     "Api",
    //     "React Libraries...",
    //   ],
    //   githubLink: "https://github.com/ryanfavour4/my-itura-app-test",
    //   liveLink: "https://curious-pudding-e9836a.netlify.app/",
    // },
    {
        projectImage: image7,
        projectName: "Homes 4 Lyfe",
        projectDescription:
            "Homes 4 Lyfe is an incoming raffle draw game site that was insisted by my client from uk to help africa win houses of stakings and lucky draws",
        languages: ["React", "Mail Chimp", "CSS", "SwiperJS"],
        githubLink: "https://github.com/ryanfavour4/homesforlife",
        liveLink: "https://homesforlife.netlify.app/",
    },
    {
        projectImage: image8,
        projectName: "Calcic Calculator",
        projectDescription:
            "This is better than a regular web developer calculator, you only have the buttons at your use and not your key pad. Try it out to see more features",
        languages: ["JavaScript", "HTML", "CSS", "PWA"],
        githubLink: "https://github.com/ryanfavour4/",
        liveLink: "https://calciccalculator.netlify.app/",
    },
    {
        projectImage: image9,
        projectName: "Xp Portal",
        projectDescription:
            "A Mimic School portal, i really put a lot of work into this. even made a v4 with React js",
        languages: [
            "JavaScript",
            "HTML",
            "CSS",
            "PostgreSQL ",
            "Node.js",
            "Express.js",
            "Bootstrap ",
        ],
        githubLink: "https://github.com/ryanfavour4/xp-university",
        liveLink: "https://github.com/ryanfavour4/xp-university",
    },
    {
        projectImage: image10,
        projectName: "Rayda Auction",
        projectDescription:
            "This was me testing my Material Ui skill from an assignment a company gave me and i did it perfectly",
        languages: [
            "TypeScript",
            "React",
            "Material UI",
            "CSS",
            "MobX",
            "Axios",
        ],
        githubLink:
            "https://github.com/ryanfavour4/rayda-aunction/tree/final-res",
        liveLink:
            "https://github.com/ryanfavour4/rayda-aunction/tree/final-res",
    },
    {
        projectImage: image11,
        projectName: "Chat App",
        projectDescription:
            "React and Firebase Chat Master. Something that really thought me lot. Real time 1 on 1",
        languages: ["JavaScript", "React", "Firebase", "CSS", "Context"],
        githubLink: "https://github.com/ryanfavour4/react-firebase-chat-master",
        liveLink: "https://github.com/ryanfavour4/react-firebase-chat-master",
    },
    {
        projectImage: image12,
        projectName: "OS-UI Replica",
        projectDescription:
            "A Portfolio webpage with touch of a developers windows operating systems and apps eg (vs code, games, pdf etc)",
        languages: ["JavaScript", "Next", "Tailwind", "Framer Motion"],
        githubLink: "https://github.com/ryanfavour4/os-ui-portfolio",
        liveLink: "https://os-ui-portfolio.vercel.app/",
    },
];
